// ** Redux Imports
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

// ** Axios Imports
import API from 'api/property_statuses'

export const list = createAsyncThunk('appPropertyStatuses/list', async () => {
  return await API.listPropertyStatuses()
})

export const get = createAsyncThunk('appPropertyStatuses/get', async name => {
  return await API.getPropertyStatus(name)
})

export const add = createAsyncThunk('appPropertyStatuses/add', async (instance, { dispatch }) => {
  const updated = await API.applyPropertyStatus(instance)
  instance = {
    ...instance,
    ...updated
  }
  await dispatch(list())
  return instance
})

export const modify = createAsyncThunk('appPropertyStatuses/modify', async (instance, { dispatch }) => {
  const updated = await API.applyPropertyStatus(instance)
  instance = {
    ...instance,
    ...updated
  }
  await dispatch(appPropertyStatusesSlice.actions.setSelected(instance))
  await dispatch(list())
})

export const del = createAsyncThunk('appPropertyStatuses/del', async (name, { dispatch }) => {
  await API.deletePropertyStatus(name)
  await dispatch(list())
  return name
})

export const appPropertyStatusesSlice = createSlice({
  name: 'appPropertyStatuses',
  initialState: {
    data: []
  },
  reducers: {
    setSelected: (state, { payload }) => {
      state.selected = payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(list.fulfilled, (state, action) => {
        state.data = action.payload
      })
      .addCase(get.fulfilled, (state, { payload }) => {
        state.selected = payload
      })
  }
})

export default appPropertyStatusesSlice.reducer
